import React, {useState} from "react";
import BackgroundMusicManager from "./music-player.tsx";
import {MusicPlayerContext} from "./music-player-context.tsx";

export function MusicPlayerProvider({children}: { children: React.ReactNode }) {
    const [musicManager] = useState(() => new BackgroundMusicManager());

    return (
        <MusicPlayerContext.Provider value={musicManager}>
            {children}
        </MusicPlayerContext.Provider>
    );
}